export const loadTikPlatGallery = () =>
    import('./experienceGalleries/tikPlatGallery').then((module) => module.default);

export const loadLetsPlanetGallery = () =>
    import('./experienceGalleries/letsPlanetGallery').then((module) => module.default);

export const loadArashBerGallery = () =>
    import('./experienceGalleries/arashBerGallery').then((module) => module.default);

export const loadYourCraftGallery = () =>
    import('./experienceGalleries/yourCraftGallery').then((module) => module.default);
